import { render, staticRenderFns } from "./uni-popups.vue?vue&type=template&id=e12aff74&scoped=true"
import script from "./uni-popups.vue?vue&type=script&lang=js"
export * from "./uni-popups.vue?vue&type=script&lang=js"
import style0 from "./uni-popups.vue?vue&type=style&index=0&id=e12aff74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e12aff74",
  null
  
)

export default component.exports